import { render } from "./px-global-error.vue?vue&type=template&id=3c17b2cc&scoped=true&ts=true"
import script from "./px-global-error.vue?vue&type=script&lang=ts"
export * from "./px-global-error.vue?vue&type=script&lang=ts"

import "./px-global-error.vue?vue&type=style&index=0&id=3c17b2cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c17b2cc"]])

export default __exports__